import { render, staticRenderFns } from "./AddonList.vue?vue&type=template&id=52550927&"
import script from "./AddonList.vue?vue&type=script&lang=js&"
export * from "./AddonList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports